import React, { useState,useEffect }  from 'react';
import { useParams } from 'react-router-dom';
function Collection() {
  const { category } = useParams(); 
  const [activeFilter, setActiveFilter] = useState('Best Sellers');
  
  useEffect(() => {
    if (category) {
      setActiveFilter(category);
    }
  }, [category]);

  const products = [
    { id: 1, image: "/images/Exc9JhlR 1.png", name: "Peach Chikankari Fabric", category: "Suit Fabric", isBestSeller: true },
    { id: 2, image: "/images/Exc9JhlR 2.png", name: "Rani Color Saree", category: "Saree", isBestSeller: true },
    { id: 3, image: "/images/Exc9JhlR 3.png", name: "Black Saree", category: "Saree", isBestSeller: false },
    { id: 4, image: "/images/Exc9JhlR 4.png", name: "Semi Stitched Chikan Suit", category: "Suit", isBestSeller: true },
    { id: 5, image: "/images/Exc9JhlR 9.png", name: "Peach Chikankari Suit Fabric", category: "Suit Fabric", isBestSeller: false },
    { id: 6, image: "/images/Exc9JhlR 10.png", name: "Beige Chikan Suit With Plazzo", category: "Suit", isBestSeller: true },
    { id: 7, image: "/images/Exc9JhlR 11.png", name: "Short Chikan Kurti", category: "Suit", isBestSeller: false },
    { id: 8, image: "/images/Exc9JhlR 12.png", name: "Pink Chikankari Fabric Material", category: "Suit Fabric", isBestSeller: false },
    { id: 9, image: "/images/Exc9JhlR 1.png", name: "Yellow Chikan Saree", category: "Saree", isBestSeller: false },
    { id: 10, image: "/images/Exc9JhlR 2.png", name: "Blue Chikan Suit", category: "Suit", isBestSeller: false },
    { id: 11, image: "/images/Exc9JhlR 3.png", name: "Green Saree", category: "Saree", isBestSeller: false },
    { id: 12, image: "/images/Exc9JhlR 4.png", name: "White Suit Fabric", category: "Suit Fabric", isBestSeller: false }
  ];

  const filterButtons = ['Best Sellers', 'Suit', 'Saree', 'Suit Fabric'];

  const filteredProducts = products.filter(product => {
    if (activeFilter === 'Best Sellers') {
      return product.isBestSeller;
    }
    return product.category === activeFilter;
  });

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };


  
  return (
    <>
     <section className="collection-grid">
        <div className="collection-item">
          <img src="/images/Image Placeholder header.png" alt="Kurtis" />
          
        </div>
        
        </section>
        <div className="center-line"> <img src="/images/Line 137.png" alt="line"></img></div>
       
     <section className="featured-collection">
      <div className="featured-container">
  <h2 className="section-title">Collection</h2>

    <div className="filter-buttons">
            {filterButtons.map((filter) => (
              <button
                key={filter}
                className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                onClick={() => handleFilterClick(filter)}
              >
                {filter}
              </button>
            ))}
          </div>
          
          <div className="product-grid">
            {filteredProducts.map((product) => (
              <div key={product.id} className="product-card">
                <img src={product.image} alt={product.name} />
                <p>{product.name}</p>
              </div>
            ))}
          </div>
    
  {/* <div className="product-grid">
     <div className="product-card">
      <img src="/images/Exc9JhlR 1.png" alt="Peach Chikankari Suit Fabric" />
      <p>Peach Chikankari  Fabric</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 2.png" alt="Beige Chikan Suit With Plazzo" />
      <p>Rani Color Saree</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 3.png" alt="Short Chikan Kurti" />
      <p>Black Saree</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 4.png" alt="Pink Chikankari Fabric Material" />
      <p>Semi Stitched Chikan Suit</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 9.png" alt="Peach Chikankari Suit Fabric" />
      <p>Peach Chikankari Suit Fabric</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 10.png" alt="Beige Chikan Suit With Plazzo" />
      <p>Beige Chikan Suit With Plazzo</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 11.png" alt="Short Chikan Kurti" />
      <p>Short Chikan Kurti</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 12.png" alt="Pink Chikankari Fabric Material" />
      <p>Pink Chikankari Fabric Material</p>
    </div>
     <div className="product-card">
      <img src="/images/Exc9JhlR 1.png" alt="Peach Chikankari Suit Fabric" />
      <p>Peach Chikankari  Fabric</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 2.png" alt="Beige Chikan Suit With Plazzo" />
      <p>Rani Color Saree</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 3.png" alt="Short Chikan Kurti" />
      <p>Black Saree</p>
    </div>
    <div className="product-card">
      <img src="/images/Exc9JhlR 4.png" alt="Pink Chikankari Fabric Material" />
      <p>Semi Stitched Chikan Suit</p>
    </div> */}
  {/* </div> */}
  </div>
</section>

       </> 

  );
}

export default Collection;
